import React, { lazy, Suspense } from 'react';
const Dashboard = lazy(() => import('./Dashboard'));

const SuspenseDashboard = ({ layout, ...others }) => {
  const { dashboard: Layout } = layout;
  return (
    <Layout>
      <Suspense fallback={<div>Loading...</div>}>
        <Dashboard />
      </Suspense>
    </Layout>
  );
};

const routes = ({ requireAuth, pluginHelper }) => [
  {
    exact: true,
    path: '/dashboard/admin/notifications/wechatwork',
    component: requireAuth(pluginHelper(SuspenseDashboard), 'admin'),
  },
];

const dashboardAdminMenu = (user, feature) =>
  [
    feature('wechatwork') && {
      icon: 'comments',
      content: 'Wechat Work',
      name: 'wechatwork',
      to: '/dashboard/admin/notifications/wechatwork',
    },
  ].filter(Boolean);

export default {
  routes,
  dashboardAdminMenu,
};
